require("./bootstrap");

window.axios.defaults.headers.common["Authorization"] = window.apiToken;
window.axios.defaults.headers.common["Accept"] = "application/json";

// window.Vue = require("vue").default;
import Vue from "vue";

import { invertColor } from "./helper.js";
import "flag-icon-css/css/flag-icon.css";
import Notifications from "vue-notification";
Vue.use(Notifications);

import filters from "./filters";
Vue.use(filters);

const VueCookie = require("vue-cookie");
Vue.use(VueCookie);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import { messages } from "./i18n.js";

const i18n = new VueI18n({
  locale: Vue.cookie.get("lang") ? Vue.cookie.get("lang") : "en",
  messages
});

import { ethers } from "ethers";

const contractAddress = window.ethgrid.contractAddress;
const contractABI = window.ethgrid.abi;

Vue.prototype.$http = axios;
Vue.prototype.$eventBus = new Vue();

// import { ValidationProvider } from "vee-validate";
// Vue.component("ValidationProvider", ValidationProvider);

Vue.component("grid-loader", require("vue-spinner/src/GridLoader.vue").default);
Vue.component("clip-loader", require("vue-spinner/src/ClipLoader.vue").default);

new Vue({
  i18n,
  el: "#app",
  data: {
    locale: "en",
    tip: "",
    contracts: {},
    currentNetwork: null,
    account: null,
    balance: 0,
    provider: null,
    signer: null
  },
  async created() {
    const self = this;
    this.locale = this.$cookie.get("lang") ? this.$cookie.get("lang") : "en";

    if (ethereum.isMetaMask) {
      try {
        if (window.ethgrid.networkId > 0) {
          this.provider = new ethers.providers.Web3Provider(
            window.ethereum,
            window.ethgrid.networkId
          );
        } else {
          this.provider = new ethers.providers.Web3Provider(window.ethereum);
        }
        // console.log(this.provider);
      } catch (error) {
        console.log(error);
      }

      // connect to MetaMask
      await this.provider.send("eth_requestAccounts", []);
      const signer = this.provider.getSigner();
      this.signer = signer;
      try {
        const network = await this.provider.getNetwork();

        if (this.currentNetwork !== network) {
          this.currentNetwork = network.name;
          this.$eventBus.$emit("network-changed", this.currentNetwork);
        }
      } catch (error) {
        console.log(error);
      }

      this.provider.on("changed", (a, b) => {
        console.log(a, b);
      });

      this.provider.on("network", (network, oldNetwork) => {
        console.log("network changed", network, oldNetwork);
        if (self.currentNetwork != network) {
          self.currentNetwork = network.name;
          self.$eventBus.$emit("network-changed", self.currentNetwork);
        }
      });
    } else {
      this.$eventBus.$emit("not-support-network", "");
    }
  },
  mounted: function() {
    const self = this;

    if (this.provider == null) {
      this.tip = this.$i18n.t("wrongBrowser");
    }
    this.$eventBus.$on("error-login", function(data) {
      console.log("error-login");
      self.tip = self.$i18n.t("loginMetaMask");
    });

    this.$eventBus.$on("network-changed", function(networkName) {
      console.log("network-changed", networkName, ethgrid.network);
      if (networkName != ethgrid.network) {
        self.$eventBus.$emit("not-support-network", networkName);
      } else {
        self.tip = "";
        self.updateAccount(self.provider);
        self.initContract();
      }
    });

    this.$eventBus.$on("not-support-network", function(data) {
      console.log("not-support-network", data);
      var message = ethgrid.network;
      if (ethgrid.network == "homestead") {
        message = "Ethereum Mainnet";
      }
      self.tip = self.$i18n.t("wrongNetwork", {
        network: message
      });
    });

    this.$eventBus.$on("buy-grid", function(tokenId) {
      self.buyHandler(tokenId);
    });

    this.$eventBus.$on("verify-account", async account => {
      self.verifyAccount(account);
    });
  },
  computed: {
    accountColor: function() {
      return invertColor(this.accountBackgroundColor, true);
    },
    accountBackgroundColor: function() {
      if (this.account) {
        return "#" + this.account.substr(-6);
      }
      return "#ffffff";
    },
    currentLang: function() {
      const langs = {
        en: "<span class='flag-icon flag-icon-us'></span>",
        cn: "<span class='flag-icon flag-icon-cn'></span>"
      };
      return langs[this.locale];
    }
  },
  methods: {
    changeLang: function(lang) {
      console.log(`${lang}, ${this.$i18n.locale} ${this.locale}`);
      if (lang == this.$i18n.locale) {
        return;
      }
      this.locale = lang;
      this.$i18n.locale = lang;
      this.$cookie.set("lang", lang, {
        expires: "1Y"
      });
    },
    async updateAccount(provider) {
      const accounts = await provider.listAccounts();
      this.account = accounts[0];

      const balance = await provider.getBalance(this.account);
      this.balance = balance;

      this.$eventBus.$emit("account-changed", accounts[0]);
    },
    initContract() {
      const contract = new ethers.Contract(
        contractAddress,
        contractABI,
        this.signer
      );
      this.contracts.CryptoGrid = contract;
      this.$eventBus.$emit("contracts-ready", contract);
    },
    markSold() {
      this.contracts.CryptoGrid.totalSupply()
        .then(function(totalSupply) {
          console.log("totalSupply", totalSupply);
        })
        .catch(function(err) {
          console.log(err.message);
        });
    },
    async buyHandler(tokenId) {
      console.log("buyHandler", tokenId);
      const self = this;
      let price = await this.contracts.CryptoGrid.priceOf(tokenId);
      if (price > 0) {
        let params = {
          from: this.account,
          value: price
        };
        let tx = await this.contracts.CryptoGrid.buyItem(tokenId, params);
        console.log("tx", tx.hash);
        this.$eventBus.$emit("buy-success", tx.hash);

        let receipt = await tx.wait();
        console.log("receipt", receipt);
      } else {
        self.$notify({
          group: "app",
          text: self.$i18n.t("invalidGrid"),
          type: "error"
        });
        console.log("token is not found.");
        self.$eventBus.$emit("buy-canceled", tokenId);
      }
    },
    async verifyAccount(account) {
      console.log("verify-account");
      const id = Date.now();
      this.$notify({
        id,
        group: "app",
        text: "Verifying ..."
      });

      const self = this;

      let localNonce = this.$cookie.get("verify");
      if (localNonce) {
        const data = { nonce: localNonce };
        let verify = await this.$http.post(
          `/api/nonce/${account}/verify`,
          data
        );
        if (verify.data.result == true) {
          self.$eventBus.$emit("verify-account-success", account);
          Vue.notify.close(id);
          return;
        } else {
          console.log("local verify failed");
        }
      }

      let nonceRes = await this.$http.get(`/api/nonce/${account}`);
      let nonce = nonceRes.data.result;

      let message = `Welcome to EthGrid.io! The message id is ${nonce}`;

      try {
        let signature = await this.signer.signMessage(message);
        // console.log("signature", signature);

        const data = {
          address: account,
          signature: signature
        };

        this.$http
          .post("/api/signature/verify", data)
          .then(response => {
            if (response.data.result == true) {
              self.$cookie.set("verify", nonce, 1);
              //TODO: add a prompt to let user know that the signature will be expired in 1 day.
              self.$eventBus.$emit("verify-account-success", account);
            } else {
              self.$eventBus.$emit("verify-account-fail", account);
            }
          })
          .catch(error => {
            // console.log(error);
            self.$eventBus.$emit("verify-account-fail", account);
          });
      } catch (error) {
        // console.log("signature dined");
        self.$eventBus.$emit("verify-account-fail", account);
      }
    }
  },
  components: {
    // "site-head": require("./components/Header.vue"),
    "grid-list": require("./components/GridList.vue").default,
    "my-grid-list": require("./components/MyGridList.vue").default,
    feedback: require("./components/Feedback.vue").default
  }
});
